module.exports = __webpack_public_path__ + "static/media/swipe.2e804735.svg";